"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var styles_1 = require("@material-ui/core/styles");
exports.default = react_1.forwardRef(function FloatinActionButtonWrapper(_a, ref) {
    var _b;
    var children = _a.children, _c = _a.left, left = _c === void 0 ? false : _c;
    var classes = useStyles();
    return (jsx_runtime_1.jsx("div", __assign({ className: classnames_1.default(classes.root, (_b = {},
            _b[classes.positionLeft] = left,
            _b)), ref: ref }, { children: children }), void 0));
});
var useStyles = styles_1.makeStyles(function (theme) { return ({
    root: {
        position: 'fixed',
        bottom: 0,
        right: 0,
        padding: theme.spacing(4),
        '& > *': {
            marginLeft: theme.spacing(2),
        },
    },
    positionLeft: {
        right: 'auto',
        left: 0,
        '& > *': {
            marginLeft: 0,
            marginRight: theme.spacing(2),
        },
    },
}); });
//# sourceMappingURL=FloatingActionButtonWrapper.js.map